var a=function(a,c,t){return Object.assign({},t?{role:"tab",id:"tab-".concat(t).concat(c),"aria-selected":a,"aria-controls":"panel-".concat(t).concat(c)}:{"aria-pressed":a})};export{a as a11yProps};
